// extracted by mini-css-extract-plugin
module.exports = {"title":"ArticoloTemplate_title__TE5gZ","imageBox":"ArticoloTemplate_imageBox__A_5Kx","date":"ArticoloTemplate_date__h2sGQ","actions":"ArticoloTemplate_actions__Dm8YN"};